import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import ReactSpeedometer from "react-d3-speedometer";
import moment from "moment";
import { ValidateLocalStorageToken } from "../../constants/provider/constant";
import DashboardImg from "../../assets/dashboard.svg";
import AppointmentsImg from "../../assets/appointments.svg";
import UprisingImg from "../../assets/uprising.svg";
import "./dashboard.scss";
import {
  GetDashboardChartData,
  GetDashboardData,
  GetTodayDashboardData,
} from "../../services/provider/common";
const NavItems = [
  {
    label: "Dashboard",
    imgSrc: DashboardImg,
  },
  // {
  //   label: "Appointments",
  //   imgSrc: AppointmentsImg,
  // },
];
const routeLists = [
  { id: 1, name: "New Appointments", routeName: "/appointments" },
  {
    id: 2,
    name: "Confirmed Appointments",
    routeName: "/appointments/confirmed",
  },
  { id: 3, name: "Documents Pending", routeName: "/documents/pending" },
  { id: 4, name: "Documents Submitted", routeName: "/documents/received" },
  { id: 5, name: "Settled", routeName: "/cases/settled" },
  { id: 6, name: "Cancelled", routeName: "/cases/cancelled" },
];
const Dashboard = () => {
  const getInitialData = (type) => {
    let data = JSON.parse(localStorage.getItem("pageTracking"));
    if (data && data[type]) return data[type];
    return type === "sla" ? false : "";
  };
  const pageTracking = ValidateLocalStorageToken(
    localStorage.getItem("pageTracking")
  );
  const history = useHistory();
  const [providerDetails, setProviderDetails] = useState("Apollo Diagnostics");
  const [todaysAppointment, setTodaysAppointment] = useState([]);
  const casePendingDays = 20;
  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardChartData, setDashboardChartData] = useState([]);
  const [startDate, setStartDate] = useState(
    pageTracking?.startTime ? pageTracking?.startTime : new Date()
  );
  console.log(pageTracking);
  const [endDate, setEndDate] = useState(
    pageTracking?.endTime ? pageTracking?.endTime : new Date()
  );
  const [chartStartDate, setChartStartDate] = useState(
    moment(new Date()).startOf("month").format("YYYY-MM-DD")
  );
  const [chartEndDate, setChartEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const [activeTab, setActiveTab] = useState(NavItems[0]);
  const [dateTimeFirst, setDateTimeFirst] = useState(
    getInitialData("startTime")
  );
  const [dateTimeSecond, setDateTimeSecond] = useState(
    getInitialData("endTime")
  );
  const routesTo = (routeName) => {
    history.push("/" + localStorage.getItem("roleName") + routeName);
    // props.toggleDrawerFunction()
  };
  console.log(
    'ValidateLocalStorageToken(localStorage.getItem("user_details")?.firstName)',
    ValidateLocalStorageToken(localStorage.getItem("user_details"))
  );
  const fetchDashboardData = async (entityId) => {
    const today = new Date();
    const data = await GetDashboardData({
      startDate: startDate ? startDate : moment(today).format("YYYY-MM-DD"),
      endDate: endDate ? endDate : moment(today).format("YYYY-MM-DD"),
      entityId: entityId,
      accesstoken: ValidateLocalStorageToken(
        localStorage.getItem("access_token")
      ),
    });
    // console.log(data);
    if (data?.status !== 200) {
      // TODO: add snack bar message
    } else {
      setDashboardData({ ...data?.data });
    }
  };
  const fetchTodayDashboardData = async () => {
    // const today = new Date();
    const providerDetails = ValidateLocalStorageToken(
      localStorage.getItem("user_details")
    );
    const data = await GetTodayDashboardData({
      entityId: providerDetails?.entityId,
    });
    // console.log(data);
    if (data?.status !== 200) {
      // TODO: add snack bar message
    } else {
      setTodaysAppointment({ ...data?.data });
    }
  };
  const fetchDashboardChartData = async () => {
    // const today = new Date();
    const providerDetails = ValidateLocalStorageToken(
      localStorage.getItem("user_details")
    );
    const data = await GetDashboardChartData({
      entityId: providerDetails?.entityId,
      chartStartDate: chartStartDate,
      chartEndDate: chartEndDate,
      reportsSlaBreachTime: "48",
      confirmedSlaBreachTime: "12",
      confirmedSlaBreachType: "RequestCreationDate",
      reportSlaBreachType: "RequestFulfillmentDate",
    });
    // console.log(data);
    if (data?.status !== 200) {
      // TODO: add snack bar message
    } else {
      setDashboardChartData({ ...data?.data });
    }
  };
  useEffect(() => {
    const providerDetails = ValidateLocalStorageToken(
      localStorage.getItem("user_details")
    );
    if (providerDetails?.entityId) {
      setProviderDetails(providerDetails);
      fetchDashboardData(providerDetails?.entityId);
      fetchDashboardChartData();
      fetchTodayDashboardData();
    }
    if (
      !(
        ValidateLocalStorageToken(localStorage.getItem("access_token")) ||
        providerDetails?.entityId
      )
    ) {
      history.push("/login");
      return null;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleTabChange = (item) => {
    setActiveTab(item);
    if (item.label === "Appointments") {
      routesTo(routeLists[0].routeName);
    }
  };
  const requestSearchFirst = (event) => {
    let firstDate = "";
    if (event.target.value === "") {
      firstDate = "";
      // props.onChangeStartDate(null);
      setStartDate(null);
      setDateTimeFirst("");
    } else {
      firstDate = new Date(event.target.value);
      let year = firstDate.getFullYear();
      let month = firstDate.getMonth() + 1;
      let day = firstDate.getDate();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      let date =
        year.toString() + "-" + month.toString() + "-" + day.toString();
      setDateTimeFirst(date);
      // props.onChangeStartDate(firstDate);
      setStartDate(firstDate);
    }
  };
  const requestSearchSecond = (event) => {
    let second = "";
    if (event.target.value === "") {
      second = "";
      // props.onChangeEndDate(null);
      setEndDate(null);
      setDateTimeSecond("");
    } else {
      second = new Date(event.target.value);
      let year = second.getFullYear();
      let month = second.getMonth() + 1;
      let day = second.getDate();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      let date =
        year.toString() + "-" + month.toString() + "-" + day.toString();
      setDateTimeSecond(date);
      // props.onChangeEndDate(second);
      setEndDate(second);
    }
  };
  // const assignPageToDashboard = (status, value) => {
  //   switch (status) {
  //     case 'confirmed': this.setPageTrack(2, value); break;
  //     case 'notAttended': this.setPageTrack(8, value); break;
  //     default: this.setPageTrack(1, value); break;
  //   }
  // }
  // const onDateSearch = (value) => {
  //   if (value) {
  //     // this.assignPageToDashboard(this.state.status, 1)
  //     this.setState({
  //       ...this.state,
  //       pageNo: this.getPageNo(this.state.status),
  //       totalRows:0
  //     }, () => {
  //       let pgTrack = JSON.parse(localStorage.getItem("pageTracking"))
  //       pgTrack.totalRows = 0;
  //       localStorage.setItem("pageTracking",JSON.stringify(pgTrack))
  //       this.callAppointmentDetails(null, this.state.pageNo, pgTrack&&pgTrack.startTime?pgTrack.startTime:this.state.startDate, pgTrack&&pgTrack.endTime?pgTrack.endTime:this.state.endDate, this.state.statusId, this.state.slaBreachType)
  //     })
  //   }
  // }
  const handleChartStartDate = (evt) => {
    setChartStartDate(evt.target.value);
  };
  const handleChartEndDate = (evt) => {
    setChartEndDate(evt.target.value);
  };
  const today = new Date();
  const seachDateClicked = () => {
    let data = JSON.parse(localStorage.getItem("pageTracking"));
    data.startTime = dateTimeFirst;
    data.endTime = dateTimeSecond;
    console.log("clicked");
    // data.totalRows = null;
    localStorage.setItem("pageTracking", JSON.stringify(data));
    fetchDashboardData(providerDetails?.entityId);
  };
  return (
    <>
      {providerDetails?.userId ? (
        <div className="container">
          <div className="dashboard-navigation">
            {NavItems.map((item) => (
              <div
                key={item.label}
                className={
                  activeTab.label === item.label
                    ? "nav-item nav-item-active"
                    : "nav-item"
                }
                role="button"
                onClick={() => handleTabChange(item)}
              >
                <div className="nav-label">{item.label}</div>
                <div className="nav-img">
                  <img src={item.imgSrc} alt={item.label} />
                </div>
              </div>
            ))}
          </div>
          <section className="dashboard-card-container">
            <div className="dashboard-card summary-card">
              <div className="card-hdr">
                <div className="card-hdr-left">
                  <h3 className="hdr-name">
                    Welcome, <div /> {providerDetails?.firstName}
                  </h3>
                </div>
                <div className="card-hdr-right">
                  <div>
                    <TextField
                      className="w-full"
                      id="date"
                      label="Starting Date"
                      type="date"
                      value={dateTimeFirst ? dateTimeFirst : ""}
                      onChange={requestSearchFirst}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                  <div className="ml-2">
                    <TextField
                      className="w-full"
                      id="date"
                      label="Ending Date"
                      type="date"
                      value={dateTimeSecond ? dateTimeSecond : ""}
                      onChange={requestSearchSecond}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                  <div className="search-icon">
                    <SearchIcon onClick={seachDateClicked} />
                  </div>
                </div>
              </div>
              <div>
                Today you have{" "}
                {dashboardData?.appointmentStatuswiseCount?.inLabAppointments?.[0]
                  ?.apptCount ? (
                  <>
                    <strong>
                      {
                        dashboardData?.appointmentStatuswiseCount
                          ?.inLabAppointments[0]?.apptCount
                      }
                    </strong>{" "}
                    In-lab Appointments and
                  </>
                ) : (
                  ""
                )}
                {dashboardData?.appointmentStatuswiseCount?.pending
                  ?.apptCount ? (
                  <>
                    <strong>
                      {" "}
                      {
                        dashboardData?.appointmentStatuswiseCount?.pending
                          ?.apptCount
                      }
                    </strong>{" "}
                    Request waiting for Confirmation
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="card-body">
                <div className="bars-wrapper">
                  {dashboardData?.appointmentStatuswiseCount ? (
                    Object.entries(
                      dashboardData?.appointmentStatuswiseCount
                    ).map(([key, value]) => (
                      <>
                        {Array.isArray(value) && (
                          <div key={key} className="bar">
                            {value?.map((item) => (
                              <>
                                {item?.percent ? (
                                  <div
                                    role="button"
                                    key={item?.statusName}
                                    className="bar-content"
                                    onClick={() => history.push(item?.url)}
                                    style={{
                                      height:
                                        parseInt(item?.percent) + 100 + "px",
                                    }}
                                  >
                                    <div className="case-count font-12">
                                      {item?.apptCount}
                                    </div>
                                    <div className="case-type font-12">
                                      {item?.statusName}
                                    </div>
                                    <div className="status-dot status-dot-red"></div>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </>
                            ))}
                          </div>
                        )}{" "}
                        {!Array.isArray(value) && (
                          <>
                            {value?.statusName !== "Outstanding" ? (
                              <div key={key} className="bar">
                                {value?.percent ? (
                                  <div
                                    className="bar-content"
                                    role="button"
                                    onClick={() => history.push(value?.url)}
                                    style={{
                                      height:
                                        parseInt(value?.percent) + 100 + "px",
                                    }}
                                  >
                                    <div className="case-count font-12">
                                      {value?.apptCount}
                                    </div>
                                    <div className="case-type font-12">
                                      {value?.statusName}
                                    </div>
                                    <div className="status-dot status-dot-yellow"></div>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            ) : (
                              <></>
                            )}
                          </>
                        )}
                      </>
                    ))
                  ) : (
                    <></>
                  )}
                </div>
                <div className="bars-text-wrapper">
                  <div className="bar-text">Pending</div>
                  <div className="bar-text">In-Lab Appointments</div>
                  <div className="bar-text">Reports</div>
                  {/* <div className="bar-text">Settled</div> */}
                </div>
              </div>
            </div>
            <div className="dashboard-card">
              <div className="card-hdr">
                <div className="card-hdr-left">
                  <h4 className="hdr-name">Today's In-Lab Appointments</h4>
                  <div className="font-12">
                    Please Mark the Attendance accordingly in "In-Lab
                    Appointments" section
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="card-slider-wrapper">
                  <div className="slider-start-val">0</div>
                  {todaysAppointment?.todayAppointment &&
                  Object.entries(todaysAppointment?.todayAppointment)
                    ?.length ? (
                    Object.entries(todaysAppointment?.todayAppointment).map(
                      ([key, value]) => (
                        <>
                          {value.percent ? (
                            <div
                              className={key}
                              style={{ width: value.percent + "%" }}
                            >
                              {value.apptCount}
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      )
                    )
                  ) : (
                    <></>
                  )}
                  <div className="slider-end-val">38</div>
                </div>
                <div className="slider-marker">
                  <div className="marker-attended">Attended</div>
                  <div className="marker-awaiting">Yet to Attend</div>
                  <div className="marker-rescheduled">Rescheduled</div>
                  <div className="marker-cancelled">Cancelled</div>
                </div>
              </div>
            </div>
            <div className="dashboard-card settled-card">
              <div className="left-card">
                <div className="settled-cases">
                  {dashboardData?.breaches?.notConfirmed}
                  <div className="status-dot status-dot-dark-red"></div>
                </div>
                <div className="settled-text">
                  Appointment Requests are waiting since {casePendingDays} days
                  for Confirmation
                </div>
              </div>
              <div className="right-card">
                <div className="settled-cases">
                  {dashboardData?.breaches?.reportsNotUploaded}
                  <div className="status-dot status-dot-dark-red"></div>
                </div>
                <div className="settled-text">
                  Report uploads are pending since {casePendingDays} days
                </div>
              </div>
            </div>
          </section>
          <section className="dashboard-widget-container">
            <div className="dashboard-card revenue-card">
              <div className="card-hdr">
                <div className="card-hdr-left">
                  <h4 className="hdr-name">Settled</h4>
                  <div className="font-12">
                    From the duration{" "}
                    {moment(startDate).format("DD-MM-YYYY") ===
                    moment(today).format("DD-MM-YYYY")
                      ? moment(startDate).startOf("month").format("DD-MM-YYYY")
                      : moment(startDate).format("DD-MM-YYYY")}{" "}
                    to {moment(endDate).format("DD-MM-YYYY")}
                  </div>
                </div>
                <div className="card-hdr-right">
                  {dashboardData?.settledData?.settledData?.apptCount}
                </div>
              </div>
              <div className="card-body">
                <div className="revenue-text">Amount Settled</div>
                <div className="revenue-amount">
                  &#8377; {dashboardData?.settledData?.settledData?.amount}
                  <img
                    className="revenue-img"
                    src={UprisingImg}
                    alt="increase"
                  />
                </div>
              </div>
            </div>
            <div className="dashboard-card score-card">
              <div className="card-hdr">
                <div className="card-hdr-left">
                  <h4 className="hdr-name">Your Performace Score</h4>
                </div>
              </div>
              <div>Calculated on your Quality of service </div>
              <div className="performance-period">
                <div className="performance-date-field">
                  <TextField
                    className="w-full"
                    id="date"
                    label="Starting Date"
                    type="date"
                    value={chartStartDate ? chartStartDate : ""}
                    onChange={handleChartStartDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="performance-date-field">
                  <TextField
                    className="w-full"
                    id="date"
                    label="Ending Date"
                    type="date"
                    value={chartEndDate ? chartEndDate : ""}
                    onChange={handleChartEndDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </div>
                <div className="search-icon">
                  <SearchIcon onClick={fetchDashboardChartData} />
                </div>
              </div>
              <div className="card-body">
                <div className="score-wrapper">
                  <h4 className="score-hdr">Appoint Confirmation Orders</h4>
                  <div className="score-chart">
                    <ReactSpeedometer
                      minValue={0}
                      maxValue={100}
                      maxSegmentLabels={0}
                      segments={2000}
                      value={dashboardChartData?.confirmedBreachPercent}
                      startColor={"#ecf4ff"}
                      endColor={"#1778F2"}
                      ringWidth={20}
                      needleColor="#1778F2"
                      needleHeightRatio={0.5}
                      textColor={"transparent"}
                      width={200}
                      height={120}
                    />
                  </div>
                  <div
                    className={
                      dashboardChartData?.confirmedBreachPercent < 50
                        ? "score-percent score-percent-red"
                        : "score-percent"
                    }
                  >
                    {dashboardChartData?.confirmedBreachPercent}%
                  </div>
                  <div className="font-12">
                    of total Appointments Confirmation were Delayed.
                  </div>
                </div>
                <div className="score-wrapper">
                  <h4 className="score-hdr">Reports Uploaded</h4>
                  <div className="score-chart">
                    <ReactSpeedometer
                      minValue={0}
                      maxValue={100}
                      maxSegmentLabels={0}
                      segments={2000}
                      value={dashboardChartData?.reportsBreachPercent}
                      label={"Good"}
                      startColor={"#ecf4ff"}
                      endColor={"#1778F2"}
                      ringWidth={20}
                      needleColor="#1778F2"
                      needleHeightRatio={0.5}
                      textColor={"transparent"}
                      width={200}
                      height={120}
                    />
                  </div>
                  <div
                    className={
                      dashboardChartData?.reportsBreachPercent < 50
                        ? "score-percent score-percent-red"
                        : "score-percent"
                    }
                  >
                    {dashboardChartData?.reportsBreachPercent}%
                  </div>
                  <div className="font-12">
                    of total Appointment’s Reports were Uploaded on Time.
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      ) : (
        <div className="container">User not found!</div>
      )}
    </>
  );
};
export default Dashboard;